import React, { useState, useEffect } from "react";
import {
    fetchAttendanceReportByProgramId, getProjectwiseCountData
} from "lib/axiosUtils";
import Spinner from 'components/Spinner';
import { LIST_ALT_ICON } from "assets/constants/Icons";
import InfoToolTip from "components/ToolTip/InfoToolTip";
import "./program.css";

const ProjectSummary = (props) => {
    const [loadingComplete, setLoadingComplete] = useState(false);
    const [programData, setProgramData] = useState(null);
    const [attendanceReport, setAttendanceReport] = useState([]);
    const [totalWeeks, setTotalWeeks] = useState([]);
    const [metaData] = useState(JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : []);

    useEffect(() => {
        if (metaData.length > 0 && metaData[0].meta_data && metaData[0].meta_data.attendance_week_list.length > 0) {
            setTotalWeeks(metaData[0].meta_data.attendance_week_list);
        }
    }, [metaData]);

    useEffect(() => {
        if (props.location.state && props.location.state.programId) {
            fetchReportData()
            fetchProjectWiseCountData();
        } else {
            setLoadingComplete(false);
            setProgramData(null);
        }
        async function fetchReportData() {
            try {
                const attendanceReportResult = await fetchAttendanceReportByProgramId({}, {}, props.location.state.programId);
                setAttendanceReport(attendanceReportResult.data.result);
            }
            catch (error) {
                console.log("Error occurred while fetching the attendance report", error);
            }
        }

        async function fetchProjectWiseCountData() {
            setLoadingComplete(true);
            try {
                const projectWiseCountData = await getProjectwiseCountData({}, {}, props.location.state.programId);
                if (projectWiseCountData && projectWiseCountData.data && projectWiseCountData.data.result) {
                    let companyName = "";
                    if (projectWiseCountData.data.result[0].company_id) {
                        companyName = metaData[0].meta_data.companies.find((findItem) => findItem.company_id === projectWiseCountData.data.result[0].company_id);
                    }
                    projectWiseCountData.data.result[0].company_name = companyName.company_name;
                    setProgramData(projectWiseCountData.data.result[0]);
                    setLoadingComplete(false);
                }
            } catch (error) {
                console.log("Error occurred while fetching project wise count data", error);
                setLoadingComplete(false);
            }
        }
    }, [props, metaData]);

    return (
        <>
            {(!props.location.state || !props.location.state.programId) ? (
                <div className="main-content">
                    <div className="text-danger">
                        Project invalid or not found.
                    </div>
                </div>
            ) : loadingComplete ? (
                <Spinner />
            ) : (
                <div className="main-content">
                    {
                        programData && (
                            <>
                                <div className="admin-dashboard-outer-wrapper employer-dashboard-outer-wrapper">
                                    <div className="project-dasboard-icon">
                                        <h4><i className={`${LIST_ALT_ICON} brand-light-color`}></i>{programData.program_name}</h4>
                                    </div>
                                    <div className="project-dashboard-outer-div">
                                        <div className="project-dashboad-total-div">
                                            <div className="project-title-div-summary project-div-background-color-summary">
                                                <div className="total-title-header-div">
                                                    <p>Project Details</p>
                                                </div>
                                            </div>
                                            <div className="project-total-value-outer-div employer-total-value-outer-div">
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Project Type : </p>
                                                    <p className="summary-total-value">{programData.project_type && programData.project_type.toUpperCase()}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Company : </p>
                                                    <p className="summary-total-value">{programData.company_name}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Program : </p>
                                                    <p className="summary-total-value">{programData.selected_program}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Project Start Date : </p>
                                                    <p className="summary-total-value">{programData.start_date_of_program}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Training Start Date : </p>
                                                    <p className="summary-total-value">{programData.training_start_date}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Service Offered : </p>
                                                    <p className="summary-total-value">{programData.service_offered}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Department : </p>
                                                    <p className="summary-total-value">{programData.department_list}</p>
                                                </div>
                                            </div>
                                            <div className="project-total-value-outer-div employer-total-value-outer-div">
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Employer Unit : </p>
                                                    <p className="summary-total-value">{programData.employers_names}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Training partner : </p>
                                                    <p className="summary-total-value">{programData.partners_names}</p>
                                                </div>
                                                <div className="summary-total-inner-div">
                                                    <p className="partner-total-inner-header">Total Batches : </p>
                                                    <p className="summary-total-value">{programData.totalBatchCount}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="seprator-line"></div>
                                        <div className="project-dashboad-total-div">
                                            <div className="total-title-div-summary">
                                                <div className="total-title-header-div">
                                                    <p>Total</p>
                                                </div>
                                            </div>
                                            <div className="total-value-outer-div-summary summary-space-between">
                                                <div className="summary-total-value-inner-div">
                                                    <div className="project-total-value-div">
                                                        <p>Candidates Expected <InfoToolTip info="Total required candidates as per project setup" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateExpected}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>Candidates Deployed <InfoToolTip info="Candidates successfully placed (Final Placement)" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDelivered}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>Deployed % <InfoToolTip info="Percentage of Candidates Deployed by Candidates Expected" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDelivered !== 0 ? Math.round((programData.candidateDelivered / programData.candidateExpected) * 100) : 0}%
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>PP Drop Out <InfoToolTip info="Candidates who dropped out after placement" /></p>
                                                        <div className="total-value-box">
                                                            {programData.postDeliveredDropout}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>PP Drop Out % <InfoToolTip info="Percentage of Candidates Post Placement Drop Out by Candidates Deliverd" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDelivered !== 0 ? Math.round((programData.postDeliveredDropout / programData.candidateDelivered) * 100) : 0}%
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="summary-total-value-inner-div">
                                                    <div className="project-total-value-div">
                                                        <p>Candidates Listed <InfoToolTip info="Number of candidates added/imported into the project" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateListed}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>Training Period Drop Out <InfoToolTip info="Candidates dropped out from project" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDropout}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>TP Drop Out % <InfoToolTip info="Percentage of Training Period Drop Out by Candidates Selected" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDropout !== 0 ? Math.round((programData.candidateDropout / programData.candidateAssigned) * 100) : 0}%
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>PR Drop Out </p>
                                                        <div className="total-value-box">
                                                            {programData.totalCandidatePostRetentionDropout}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>PR Drop Out % </p>
                                                        <div className="total-value-box">
                                                            {programData.candidateDelivered !== 0 ? Math.round((programData.totalCandidatePostRetentionDropout / programData.candidateDelivered) * 100) : 0}%
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                                <div className="summary-total-value-inner-div">
                                                    <div className="project-total-value-div">
                                                        <p>Candidates Selected <InfoToolTip info="Candidates selected through interview(s)" /></p>
                                                        <div className="total-value-box">
                                                            {programData.candidateAssigned}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>Total Male <InfoToolTip info="Total male Candidates Selected to project"/></p>
                                                        <div className="total-value-box">
                                                            {programData.totalMale}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div">
                                                        <p>Total Female<InfoToolTip info="Total female Candidates Selected to project"/></p>
                                                        <div className="total-value-box">
                                                            {programData.totalFemale}
                                                        </div>
                                                    </div>
                                                    <div className="project-total-value-div"></div>
                                                    <div className="project-total-value-div"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    {
                        attendanceReport && (
                            <div className="attendance-page-table-outer-wrapper attendance-photo-upload-table-wrapper project-summary-attendance">
                                <label>Attendance Report</label>
                                <table className="attendance-table-table table-summary">
                                    <thead>
                                        <tr className="program-modal-main-row-header">
                                            <th className="serial-no-th-width text-center padding-right-0">Sr No</th>
                                            <th className="width-250px width-responsive-attendance-column padding-left-5">Name</th>
                                            {
                                                totalWeeks && totalWeeks.length > 0 && (
                                                    totalWeeks.map((weekItem, weekIdx) => {
                                                        return (
                                                            <th
                                                                className="text-center padding-left-10"
                                                                key={`week-header-${weekItem}-${weekIdx}`}
                                                            >
                                                                {weekItem}
                                                            </th>
                                                        );
                                                    })
                                                )
                                            }
                                            <th className="text-center padding-left-10">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            attendanceReport.map((listItem, index) => {
                                                let rowClass = "";
                                                let below80Color = ""
                                                if (index % 2) {
                                                    rowClass = "program-modal-row-background-color"
                                                }
                                                return (
                                                    <tr className={rowClass} key={`project-attendance-${index}`}>
                                                        <td className="text-center" key={`first-td-${listItem._id}`}>{index + 1}</td>
                                                        <td className="padding-left-5" key={`second-td-${listItem._id}`}>{`${listItem.first_name} ${listItem.last_name}`}</td>
                                                        {
                                                            totalWeeks && totalWeeks.length > 0 && (
                                                                totalWeeks.map((item, weekIdx) => {
                                                                    const repaceText = item.toLowerCase().replace("-", "_");
                                                                    if (listItem[repaceText]) {
                                                                        const weekDataObject = listItem[repaceText];
                                                                        if (weekDataObject.percentage && weekDataObject.percentage < 80) {
                                                                            below80Color = "percentage-below-80-color"
                                                                        }
                                                                        else {
                                                                            below80Color = ""
                                                                        }
                                                                        return (
                                                                            <td
                                                                                key={`week-${item}-${listItem._id}-${weekIdx}`}
                                                                                className={`${below80Color} text-center`}
                                                                            >
                                                                                {weekDataObject.percentage ? `${weekDataObject.percentage} %` : ""}
                                                                            </td>
                                                                        )
                                                                    }
                                                                    else {
                                                                        return <td key={`week-empty-${item}-${listItem._id}-${weekIdx}`}></td>
                                                                    }
                                                                })
                                                            )
                                                        }
                                                        <td className={listItem.totalPresentPercentage && listItem.totalPresentPercentage < 80 ? "percentage-below-80-color text-center" : "text-center"}>{listItem.totalPresentPercentage ? `${listItem.totalPresentPercentage} %` : ""}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody >
                                </table>
                            </div>
                        )
                    }
                </div>
            )}
        </>
    );
};

export default ProjectSummary;